import { gql } from '@apollo/client';

export const CANCEL_CHARGING_SESSION = gql`
  mutation cancelChargingSession($input: CancelChargingSessionInput!) {
    cancelChargingSession(input: $input) {
      startTime
      endTime
    }
  }
`;
